import { Link } from "react-router-dom";
import { styled } from "styled-components";

export const MenuContainer = styled.nav`
  display: flex;
  background-color: transparent;
  padding: 0;
`;

export const MenuItemStyled = styled.div<{ $active: boolean }>`
  margin: 0 ${({ theme }) => theme.spacing.sm};
  padding: ${({ theme }) => theme.spacing.sm} ${({ theme }) => theme.spacing.md};
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  background-color: ${({ $active, theme }) =>
    $active ? theme.colors.subtle_5 : "transparent"};
  transition: background-color ${({ theme }) => theme.transitions.normal};

  &:hover {
    background-color: ${({ theme }) => theme.colors.subtle_8};
  }
`;

export const MenuLink = styled(Link)<{ $active: boolean }>`
  text-decoration: none;
  color: ${({ $active, theme }) =>
    $active ? theme.colors.primary : theme.colors.secondary};
  font-size: ${({ theme }) => theme.fontSizes.md};
  font-weight: 500;
  display: flex;
  align-items: center;
  transition: color ${({ theme }) => theme.transitions.fast};

  svg {
    margin-right: ${({ theme }) => theme.spacing.sm};
  }

  &:hover,
  &:active {
    color: ${({ theme }) => theme.colors.primary};
  }

  &:focus,
  &:active {
    outline: none;
  }
`;
